"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var EmailField = /** @class */ (function (_super) {
    __extends(EmailField, _super);
    function EmailField(key, isRequired, label, initialValue) {
        var _this = _super.call(this, key, label ? label : 'Email Address', isRequired, 50, 'Email is required', initialValue) || this;
        _this.key = key;
        return _this;
    }
    Object.defineProperty(EmailField.prototype, "errorMessage", {
        get: function () {
            var baseErrorMessage = _super.prototype.getErrorMessage.call(this);
            if (baseErrorMessage) {
                return baseErrorMessage;
            }
            if (this.value && !this.isValidEmail() && this.isDirty) {
                return 'Email is invalid';
            }
            return baseErrorMessage;
        },
        enumerable: false,
        configurable: true
    });
    EmailField.prototype.isValidEmail = function () {
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(this.value.trim().toString());
    };
    EmailField.prototype.isValid = function () {
        var isValid = true;
        if (!this.checkRequiredStatus()) {
            isValid = false;
        }
        if (this.stringValue && !this.isValidEmail()) {
            isValid = false;
        }
        this.setIsValid(isValid);
        return isValid;
    };
    return EmailField;
}(_1.TextField));
exports.default = EmailField;
